import { render, staticRenderFns } from "./CurriculumNote.vue?vue&type=template&id=1c5d8342&"
import script from "./CurriculumNote.vue?vue&type=script&lang=js&"
export * from "./CurriculumNote.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumNote.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports